<template>
    <div class="home" @click="goChoose" :style="{height:screenHeight + 'px',width:screenWidth +'px'}">
        <div class="bd">
            <img src="../../static/home.png" mode="top right" style="width:100%;height:100%">
            <div class="content" @click="goChoose">
                <div style="color:black;font-size:5rem;font-weight: bold;text-align: center;font-family: 'jxzhuokai'">
                    穿越千年
                </div>
                <div style="color:black;font-size:5rem;font-weight: bold;text-align: center;font-family: 'jxzhuokai'">之
                </div>
                <div style="color:black;font-size:5rem;font-weight: bold;text-align: center;font-family: 'jxzhuokai'">
                    百工映像
                </div>
            </div>
            <div class="baigongshijie">进入百工世界</div>
            <div class="fl_remove">
                <img src="../../static/u11.png" style="width:6rem;height: 6rem;">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            screenWidth:0,
            screenHeight:0
        }
    },
    mounted(){
        window.screenWidth = document.body.clientWidth;
        window.screenHeight = document.documentElement.clientHeight;
        this.screenWidth = window.screenWidth;
        this.screenHeight = window.screenHeight;
    },
    methods: {
        goChoose() {
            this.$router.push('/baigongfeiyi/chooseRole')
        }
    }
}
</script>
<style scoped>

.home {
    width: 100%;
    height: 150rem;
    box-sizing: border-box;
    background-color: rgba(255, 255, 255, 1);
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    opacity: 1;
    background: transparent url('../../static/homeBackground.png') 0% 0% padding-box;
    background-size: 100%;
}
 .bd {
     width: 100%;
     height: 100%;
     position: fixed;
     top: 0;
     z-index:10;

 }

.content {
    width: 80%;
    height: 20rem;
    margin-top: 10rem;
    position: absolute;
    top: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-left: 10%;
    background-color: #FFFFFF;
    opacity: 0.7;
    border-radius: 15px ;

}

.baigongshijie {
        font-size: 5rem;
        font-family: 'jxzhuokai';
        position: absolute;
        bottom: 40rem;
        width: 80%;
        text-align: center;
        margin-left: 10%;
        background-color: #FFFFFF;
        opacity: 0.7;
        border-radius: 10px;
}

.fl_remove {
    position: absolute;
    top: 7rem;
    right: 5rem;
}
</style>